/*
  The cart's two vehicle-aware surfaces.

  Liquid cannot read the hrllc_vehicle cookie, so both of these are filled in
  on the client: the per-item fitment line, and the empty state's recovery.
  Everything either of them says is either a fact the server rendered or a
  verdict the shipped fitment engine returned. Nothing here infers a verdict.

  It does not touch the cart's AJAX. It listens for the theme's own cart
  events and re-reads the DOM afterwards, because the cart replaces
  `.js-contents` wholesale on every quantity change and any line written
  before that goes with it.
*/
(function saikospeedCart() {
  'use strict';

  function engine() {
    return window.SaikoSpeedFitment || null;
  }

  function savedVehicle() {
    var api = engine();
    if (!api) return null;
    return api.parseVehicleCookie(document.cookie);
  }

  // "2018 Honda Civic Si", the exact shape the browse surfaces print.
  function vehicleLabel(vehicle) {
    if (!vehicle) return '';
    return [vehicle.year, vehicle.make, vehicle.model, vehicle.submodel]
      .filter(Boolean)
      .join(' ');
  }

  function readFitments(row) {
    var raw = row.getAttribute('data-cart-fitments');
    if (!raw) return null;
    try {
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : null;
    } catch (error) {
      return null;
    }
  }

  /*
    One line per item, and only for a confirmed match.

    Kevin ratified confirmation only: no not-confirmed warning renders here,
    because raising doubt at the moment a shopper commits is a decision about
    the business, not about the markup. An item with no rows, no saved vehicle
    or an unconfirmed verdict says nothing at all rather than something hedged.
  */
  function paintItemFitment() {
    var api = engine();
    var slots = document.querySelectorAll('[data-cart-fits]');
    if (!api) return;

    var vehicle = savedVehicle();
    var label = vehicleLabel(vehicle);

    Array.prototype.forEach.call(slots, function (slot) {
      var row = slot.closest('.cart-item');
      slot.textContent = '';
      slot.hidden = true;
      if (!row || !vehicle) return;

      var rows = readFitments(row);
      if (!rows || rows.length === 0) return;

      var state = api.resolveFitmentState(api.parseFitmentEntries(rows), vehicle);
      if (state.status !== 'confirmed') return;

      slot.textContent = 'Fits your ' + label;
      slot.hidden = false;
    });
  }

  /*
    The empty state, when a vehicle is saved.

    The server renders a complete state on its own, so this only upgrades it.
    The destination is /search with the make and model as the query, which is
    the same route the home hero uses for a completed vehicle: the search page
    then reads the same cookie and applies the vehicle itself. /collections/all
    cannot facet fitment, which is why it is not the target.
  */
  function paintEmptyState() {
    var lede = document.querySelector('[data-cart-empty-lede]');
    var action = document.querySelector('[data-cart-empty-action]');
    if (!lede && !action) return;

    var vehicle = savedVehicle();
    if (!vehicle) return;

    var label = vehicleLabel(vehicle);
    if (lede) lede.textContent = 'Nothing in it yet. Pick up where you left off with your ' + label + '.';

    if (action) {
      var query = [vehicle.make, vehicle.model].filter(Boolean).join(' ');
      action.setAttribute('href', '/search?q=' + encodeURIComponent(query));
      var caret = action.querySelector('svg');
      action.textContent = 'Shop parts for your ' + label + ' ';
      if (caret) action.appendChild(caret);
    }
  }

  var observer = null;
  var scope = null;

  /*
    Paint writes into the very subtree the observer watches, so it has to stop
    watching while it does. Without this the first repaint feeds itself and the
    observer runs until the tab gives up.
  */
  function paint() {
    if (observer) observer.disconnect();
    try {
      paintItemFitment();
      paintEmptyState();
    } finally {
      if (observer && scope) observer.observe(scope, { childList: true, subtree: true });
    }
  }

  function start() {
    /*
      The cart replaces `.js-contents` on every quantity change and removal,
      which takes the fitment lines with it. Watching the node the cart really
      rewrites is what carries this, rather than guessing at the theme's own
      cart events.
    */
    scope = document.querySelector('cart-items');
    if (scope && typeof MutationObserver === 'function') {
      observer = new MutationObserver(function () { paint(); });
    }

    paint();

    document.addEventListener('shopify:section:load', paint);
    window.addEventListener('pageshow', paint);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());
